import React, { useContext, useEffect, useState } from "react";
import { Form, Formik, FormikProps } from "formik";
import { useLazyQuery, useMutation } from "@apollo/client";
import PhoneInput from "react-phone-input-2";
import {
  empType,
  LicenseTypes,
  Operation,
  PriorityEnum,
} from "../../../../../../utils/Enum.types";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useFormJson from "../../../../../../json/useFormJson";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import { AppContext } from "../../../../../../context/context";
import {
  AddJunctionResult,
  AddJunctionVars,
  CreateAtsJunctionsFormType,
  Junction,
  JunctionQueryType,
  UpdateJunctionResult,
  UpdateJunctionVars,
} from "./queries/types";
import useLabels from "../../../../../../customHooks/useLabels";
import LoadingModal from "../../../../../pages/LoadingModal";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { Button } from "../../../../../../stories/Button/Button";
import { Label } from "../../../../../../stories/Label/Label";
import {
  handleFormEvent,
  handleMUISelectEvent,
  hanldeTextAreaFormEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import { Keys } from "../../../../../../utils/Enum.keys";
import { GetJunctionNode, GetJunctions } from "./queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import { AddJunction, UpdateJunction } from "./queries/mutations";
import { AtsSubsidiaryOrderField } from "../queries/types";
import { Title } from "../../../../../../stories/Title/Title";
import { LabelProps } from "../../../../../../utils/types";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import InputNumber from "../../../../../common/Input/InputNumber";
import PredefinedSelect from "../../../../../../customComponents/PredefinedSelect";
import { PredefinedDataTypes } from "../../../../../../utils/formTypes";
import InputHoc from "../../../../../common/Input/Index";
import { junctoinLabel } from "../../../../../../utils/validationSchema";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import IconSelect from "../../../../../../customComponents/IconSelect";
import SuppliersSelect from "../../../purchase/purchaseorder/rfqtopo/components/SuppliersSelect";
import { LdgrQueryType } from "../../supplier/queries/types";
import { TableType } from "../../../../customer/companies/queries/types";
import JunctionStatusAutocomplete from "./customComponenets/JunctionStatusAutocomplete";
import Navbar from "../../../../../common/layout/Navbar";
import CompaniesAutocomplete from "../../../../customer/companies/CompaniesAutocomplete";
import SubsidiarySelect from "../../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../../customComponents/SiteSelect";
import { payloadTypes } from "../../../../../../context/reducer";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  operation: Operation;
}

const AddJunctions = ({ operation, setModalFlag }: Props) => {
  const { JunctionsFormLabels } = useFormJson();

  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState(emptyMessage);

  const { company_id, customer_id, siteID, sub_id } = useUrlParams();

  const { state, dispatch } = useContext(AppContext);

  const priorityOptions = Object.values(PriorityEnum);
  const initialValues: CreateAtsJunctionsFormType = {
    address: "",
    code: "",
    country: "",
    latitude: "",
    longitude: "",
    name: "",
    pin: "",
    place: "",
    state: "",
    priority: PriorityEnum.LOW,
    alias: "",
    jType: "",
    arms: 0,
    icon: "",
    poles: 0,
    ldgrID: 0,
    junctionStatus: null,
    remarks: "",
  };
  const {
    junctionLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    companyLabel,
    ledgerLabel,
  } = useLabels();
  const [formData, setFormData] =
    useState<CreateAtsJunctionsFormType>(initialValues);

  const [GetJunctionByNode, { loading: GetJunctionLoading }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(GetJunctionNode);

  const [Add, { loading: AdJunctionLoading }] = useMutation<
    AddJunctionResult,
    AddJunctionVars
  >(AddJunction, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const [UpdateJunctionDetails, { loading: UpdateJunctionLoading }] =
    useMutation<UpdateJunctionResult, UpdateJunctionVars>(UpdateJunction, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<CreateAtsJunctionsFormType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    let finalValue = "";
    if (e.target.name === "gstNo") {
      finalValue = value.toLocaleUpperCase();
    } else {
      finalValue = value;
    }
    setFormData(() => ({
      ...formData,
      [name]: finalValue,
    }));
    meta.handleChange(e);
  };

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      "name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(initialValues);
    dispatch({
      type: payloadTypes.SET_COMPANY_ID,
      payload: {
        companyId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_ID,
      payload: {
        subsidiaryId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_SITE_ID,
      payload: {
        subSiteId: 0,
      },
    });
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setModalFlag(false);
    }
  };

  const handleSubmit = async () => {
    if (formData.junctionStatus === null) {
      setMessage({
        flag: true,
        message: "Junction Status is required",
        operation: Operation.NONE,
      });
      return;
    }

    if (customer_id && (company_id || state.companyId)) {
      if (operation === Operation.CREATE) {
        const empAdded = Add({
          variables: {
            user_details,
            input: {
              name: removeMoreSpace(formData.name),
              address: removeMoreSpace(formData.address),
              place: removeMoreSpace(formData.place),
              pin: formData.pin,
              state: formData.state,
              latitude: Number(formData.latitude),
              longitude: Number(formData.longitude),
              code: removeMoreSpace(formData.code),
              country: formData.country,
              priority: formData.priority as PriorityEnum,
              alias: formData.alias,
              jType: formData.jType,
              arms: formData.arms,
              icon: formData.icon,
              poles: formData.poles,
              ldgrID: formData.ldgrID,
              junctionStatus: formData.junctionStatus,
              remarks: formData.remarks,
            },
            companyID: state.companyId
              ? Number(state.companyId)
              : company_id
              ? company_id
              : 0,
            customerID: customer_id,
            siteID: state.subSiteId
              ? Number(state.subSiteId)
              : siteID
              ? siteID
              : 0,
            subsidiaryID: state.subsidiaryId
              ? Number(state.subsidiaryId)
              : sub_id
              ? sub_id
              : 0,
          },
          refetchQueries: [
            {
              query: GetJunctions,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id
                  ? company_id
                  : state.companyId
                  ? state.companyId
                  : 0,
                first: ROWS_PER_PAGE,
                empID: user_details.id,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiaryOrderField.NAME,
                },
                priority: [],
                jType: [],
                name: EMPTY_STRING,
                subsidiaryID: sub_id
                  ? sub_id
                  : state.subsidiaryId
                  ? state.subsidiaryId
                  : 0,
                siteID: siteID ? siteID : state.subSiteId ? state.subSiteId : 0,
                ldgrID: state.supplierId ? state.supplierId : 0,
                queryType: JunctionQueryType.ALL,
              },
            },
          ],
        });
        const { data } = await empAdded;

        if (data && data.AddJunction) {
          setMessage({
            flag: true,
            message: `${junctionLabel} added successfully`,
            operation: Operation.CREATE,
          });
        }
      } else {
        const junctionUpdated = UpdateJunctionDetails({
          variables: {
            user_details,
            input: {
              name: removeMoreSpace(formData.name),
              address: removeMoreSpace(formData.address),
              place: removeMoreSpace(formData.place),
              pin: formData.pin,
              state: formData.state,
              latitude: Number(formData.latitude),
              longitude: Number(formData.longitude),
              code: removeMoreSpace(formData.code),
              country: formData.country,
              priority: formData.priority as PriorityEnum,
              alias: formData.alias,
              jType: formData.jType,
              arms: formData.arms,
              icon: formData.icon,
              poles: formData.poles,
              ldgrID: formData.ldgrID,
              junctionStatus: formData.junctionStatus,
              remarks: formData.remarks,
              companyID: state.companyId
                ? Number(state.companyId)
                : company_id
                ? company_id
                : 0,
              siteID: state.subSiteId
                ? Number(state.subSiteId)
                : siteID
                ? siteID
                : 0,
              subsidiaryID: state.subsidiaryId
                ? Number(state.subsidiaryId)
                : sub_id
                ? sub_id
                : 0,
            },
            junctionID: state.junctionID ? state.junctionID : 0,
          },
          refetchQueries: [
            {
              query: GetJunctions,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id
                  ? company_id
                  : state.companyId
                  ? state.companyId
                  : 0,
                first: ROWS_PER_PAGE,
                empID: user_details.id,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiaryOrderField.NAME,
                },
                priority: [],
                jType: [],
                name: EMPTY_STRING,
                subsidiaryID: sub_id
                  ? sub_id
                  : state.subsidiaryId
                  ? state.subsidiaryId
                  : 0,
                siteID: siteID ? siteID : state.subSiteId ? state.subSiteId : 0,
                ldgrID: state.supplierId ? state.supplierId : 0,
                queryType: JunctionQueryType.ALL,
              },
            },
          ],
        });
        const { data } = await junctionUpdated;

        if (data && data.UpdateJunction) {
          setMessage({
            flag: true,
            message: `${junctionLabel} details updated successfully`,
            operation: Operation.CREATE,
          });
        }
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (state.junctionID && operation === Operation.UPDATE) {
        GetJunctionByNode({
          variables: {
            id: state.junctionID,
          },
        }).then(({ data }) => {
          if (data && data.node) {
            setFormData({
              name: removeMoreSpace(data.node.name),
              address: removeMoreSpace(data.node.address),
              place: removeMoreSpace(data.node.place),
              pin: data.node.pin,
              state: data.node.state,
              code: data.node.code,
              country: data.node.country,
              latitude: data.node.latitude ? data.node.latitude : "",
              longitude: data.node.longitude ? data.node.longitude : "",
              priority: data.node.priority,
              alias: data.node.alias,
              jType: data.node.jType,
              arms: data.node.arms,
              icon: data.node.icon,
              poles: data.node.poles,
              ldgrID: data.node.ldgrID,
              junctionStatus: data.node.junctionStatus,
              remarks: data.node.remarks ? data.node.remarks : "",
            });
            dispatch({
              type: payloadTypes.SET_COMPANY_ID,
              payload: {
                companyId: data.node.companyID,
              },
            });
            dispatch({
              type: payloadTypes.SET_SUB_ID,
              payload: {
                subsidiaryId: data.node.subsidiaryID,
              },
            });
            dispatch({
              type: payloadTypes.SET_SUB_SITE_ID,
              payload: {
                subSiteId: data.node.siteID,
              },
            });
          }
        });
      }
    };
    fetchData();
  }, [GetJunctionByNode, operation]);

  useEffect(() => {
    if (operation === Operation.CREATE) {
      hanldeClear();
    }
  }, [operation]);

  const handleNumberChange = (name: string, value: string) => {
    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
  };

  return (
    <>
      <Title>
        {operation === Operation.CREATE ? "Add " : "Edit "}
        {junctionLabel} Details
      </Title>
      <Formik
        initialValues={formData}
        validationSchema={junctoinLabel}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="add-junctions">
              <div className="add-junctions__block">
                {(state.empSubType === empType.PMU ||
                  state.empSubType === empType.SYS_ADMIN) && (
                  <>
                    <div className="label-grid">
                      <Label>{companyLabel}</Label>
                      <CompaniesAutocomplete
                        onChange={(newValue) => {
                          if (newValue) {
                            dispatch({
                              type: payloadTypes.SET_COMPANY_ID,
                              payload: {
                                companyId: newValue.node.id,
                              },
                            });
                          } else {
                            dispatch({
                              type: payloadTypes.SET_COMPANY_ID,
                              payload: {
                                companyId: 0,
                              },
                            });
                            dispatch({
                              type: payloadTypes.SET_SUB_ID,
                              payload: {
                                subsidiaryId: 0,
                              },
                            });
                            dispatch({
                              type: payloadTypes.SET_SUB_SITE_ID,
                              payload: {
                                subSiteId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={state.companyId ? state.companyId : 0}
                        label={""}
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{subsidiaryLabel}</Label>
                      <SubsidiarySelect
                        onChange={(newValue) => {
                          if (newValue) {
                            dispatch({
                              type: payloadTypes.SET_SUB_ID,
                              payload: {
                                subsidiaryId: newValue.node.id,
                              },
                            });
                          } else {
                            dispatch({
                              type: payloadTypes.SET_SUB_ID,
                              payload: {
                                subsidiaryId: 0,
                              },
                            });
                            dispatch({
                              type: payloadTypes.SET_SUB_SITE_ID,
                              payload: {
                                subSiteId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        companyID={state.companyId ? state.companyId : 0}
                        value={state.subsidiaryId ? state.subsidiaryId : 0}
                        label={""}
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{subsidiarySiteLabel}</Label>
                      <SiteSelect
                        onChange={(newValue) => {
                          if (newValue) {
                            dispatch({
                              type: payloadTypes.SET_SUB_SITE_ID,
                              payload: {
                                subSiteId: newValue.value,
                              },
                            });
                          } else {
                            dispatch({
                              type: payloadTypes.SET_SUB_SITE_ID,
                              payload: {
                                subSiteId: 0,
                              },
                            });
                          }
                        }}
                        companyId={state.companyId ? state.companyId : 0}
                        subsidiaryId={
                          state.subsidiaryId ? state.subsidiaryId : 0
                        }
                        onKeyDown={emptyFunc}
                        value={state.subSiteId ? state.subSiteId : 0}
                        label={""}
                      />
                    </div>
                  </>
                )}

                {JunctionsFormLabels.map(
                  (field: LabelProps, key: React.Key) => {
                    if (field.dataType === "textarea") {
                      return (
                        <React.Fragment key={key}>
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <TextArea
                              value={formData[field.inputName]}
                              onChange={(
                                e: React.ChangeEvent<HTMLTextAreaElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              onKeyDown={(e) =>
                                hanldeTextAreaFormEvent(
                                  e,
                                  setFormData as (
                                    value: React.SetStateAction<{
                                      [key: string]: string | number;
                                    }>
                                  ) => void
                                )
                              }
                              type={field.dataType}
                              rows={3}
                              name={field.inputName}
                              required={true}
                            />
                          </div>
                          {meta.touched[field.inputName] &&
                          meta.errors[field.inputName] ? (
                            <div className="label-grid">
                              <span className="nodata">
                                {meta.errors[field.inputName]}
                              </span>
                            </div>
                          ) : null}
                        </React.Fragment>
                      );
                    } else if (field.dataType === "number") {
                      return (
                        <React.Fragment key={key}>
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <InputNumber
                              value={formData[field.inputName]}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              onKeyDown={handleFormEvent}
                              name={field.inputName}
                              required={field.required}
                              maxLength={field.maxLength}
                            />
                            {meta.touched[field.inputName] &&
                            meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </div>
                        </React.Fragment>
                      );
                    } else if (field.dataType === "city") {
                      return (
                        <div className="label-grid">
                          <Label>{field.labelName}</Label>
                          <PredefinedSelect
                            label=""
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                place: e,
                              });
                            }}
                            type={PredefinedDataTypes.CITY}
                            value={formData.place as string}
                            name={field.inputName as string}
                          />
                        </div>
                      );
                    } else if (field.dataType === "state") {
                      return (
                        <div className="label-grid">
                          <Label>{field.labelName}</Label>
                          <PredefinedSelect
                            label=""
                            onChange={(e, state_code) => {
                              setFormData({
                                ...formData,
                                state: e,
                                gstStateCode: state_code
                                  ? state_code
                                  : EMPTY_STRING,
                              });
                            }}
                            type={PredefinedDataTypes.STATE}
                            value={formData.state as string}
                            name={field.inputName}
                          />
                        </div>
                      );
                    } else if (field.dataType === "mobile") {
                      return (
                        <div className="label-grid" key={key}>
                          <Label>{field.labelName}</Label>
                          <PhoneInput
                            country={"in"}
                            value={formData[field.inputName] as string}
                            onChange={(e: string) => {
                              handleNumberChange(field.inputName, e);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                e.preventDefault();
                                handleMUISelectEvent(e);
                              }
                            }}
                            inputProps={{
                              required: true,
                            }}
                          />
                          {meta.touched[field.inputName] &&
                          meta.errors[field.inputName] ? (
                            <div className="label-grid">
                              <span />

                              <span className="nodata">
                                {meta.errors[field.inputName]}
                              </span>
                            </div>
                          ) : null}
                        </div>
                      );
                    } else if (field.dataType === "country") {
                      return (
                        <div className="label-grid">
                          <Label>{field.labelName}</Label>
                          <PredefinedSelect
                            label=""
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                country: e,
                              });
                            }}
                            type={PredefinedDataTypes.COUNTRY}
                            value={formData.country as string}
                            name={field.inputName}
                          />
                        </div>
                      );
                    } else if (field.dataType === "priority") {
                      return (
                        <div className="label-grid">
                          <Label>{field.labelName}</Label>
                          <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={priorityOptions}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                e.preventDefault();
                                handleMUISelectEvent(e);
                              }
                            }}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                setFormData({
                                  ...formData,
                                  priority: newValue as string,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  priority: "",
                                });
                              }
                            }}
                            value={formData.priority}
                            openOnFocus
                            forcePopupIcon
                            freeSolo
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                className={formClasses.formControlRoot}
                              />
                            )}
                          />
                        </div>
                      );
                    } else if (field.dataType === "icon") {
                      return (
                        <IconSelect
                          onChange={(newValue) => {
                            if (newValue) {
                              setFormData({
                                ...formData,
                                icon: newValue.value as unknown as string,
                              });
                            } else {
                              setFormData({
                                ...formData,
                                icon: "",
                              });
                            }
                          }}
                        />
                      );
                    } else if (field.dataType === "ldgrID") {
                      return (
                        <div className="label-grid" key={key}>
                          <Label>{field.labelName}</Label>
                          <SuppliersSelect
                            onChange={(newValue) => {
                              if (newValue) {
                                setFormData({
                                  ...formData,
                                  ldgrID: newValue.value as number,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  ldgrID: 0,
                                });
                              }
                            }}
                            value={formData.ldgrID ? formData.ldgrID : 0}
                            input={{
                              itemID: 0,
                              query_type: LdgrQueryType.ALL,
                              tableLevel: TableType.JUNCTION,
                            }}
                          />
                        </div>
                      );
                    } else if (field.dataType === "junctionStatus") {
                      return (
                        <div className="label-grid" key={key}>
                          <Label>{field.labelName}</Label>
                          <JunctionStatusAutocomplete
                            onChange={(newValue) => {
                              if (newValue) {
                                setFormData({
                                  ...formData,
                                  junctionStatus: newValue.value,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  junctionStatus: null,
                                });
                              }
                            }}
                            value={formData.junctionStatus}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                e.preventDefault();
                                handleMUISelectEvent(e);
                              }
                            }}
                          />
                        </div>
                      );
                    } else {
                      return (
                        <React.Fragment key={key}>
                          <InputHoc
                            LabelName={field.labelName}
                            values={formData[field.inputName]}
                            name={field.inputName}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              handleValueChange(e, meta);
                            }}
                            required={field.required}
                            autoFocus={field.autoFocus}
                          />

                          {meta.touched[field.inputName] &&
                          meta.errors[field.inputName] ? (
                            <div className="label-grid">
                              <span></span>
                              <span className="nodata">
                                {meta.errors[field.inputName]}
                              </span>
                            </div>
                          ) : null}
                        </React.Fragment>
                      );
                    }
                  }
                )}
              </div>
              <Button mode="save" type="submit" />
              <Button mode="clear" type="button" onClick={hanldeClear} />
              <Button
                mode="cancel"
                onClick={() => {
                  setModalFlag(false);
                }}
              />
              <MessageModal
                handleClose={handleClose}
                modalFlag={message.flag}
                operation={message.operation}
                value={message.message}
              />
            </Form>
          );
        }}
      </Formik>
      <LoadingModal
        flag={GetJunctionLoading || AdJunctionLoading || UpdateJunctionLoading}
      />
    </>
  );
};

export default AddJunctions;
